import styled from 'styled-components/macro'

export const Wrapper = styled.div`
  width: 100%;
  height: calc(100vh - 58px);
  overflow: hidden;

  .layout {
    display: flex;
    height: 100%;
    width: 100%;

    @media (max-width: 768px) {
      flex-direction: column-reverse;
    }
  }

  .sidebar {
    width: min(500px, 25vw);
    min-width: 380px;
    height: 100%;
    border-right: 1px solid ${props => props.theme.border};
    background: ${props => props.theme.white};

    display: flex;
    flex-direction: column;
    overflow: hidden;

    @media (max-width: 768px) {
      width: 100%;
      min-width: 100%;
      height: 100%;
      border-right: none;
      border-top: 1px solid ${props => props.theme.border};
    }
  }

  .drawing-explainer {
    background: ${props => props.theme.blue};
    color: ${props => props.theme.white};
    padding: 16px 24px;
    font-weight: 500;
    text-align: left;
    display: flex;
    flex-direction: column;
    gap: 16px;

    .drawing-explainer-header {
      display: flex;
      align-items: center;
      gap: 8px;

      svg {
        color: ${props => props.theme.white};
        font-size: 18px;
      }

      h4 {
        margin: 0;
        font-size: 16px;
        font-weight: 700;
        color: inherit;
      }

      button.button {
        margin-top: 0;
      }
    }

    button {
      align-self: flex-start;
      min-width: 120px;
      margin-top: 4px;
    }
  }

  .info-banner {
    padding: 16px;
    background: ${props => props.theme.activeBackground};
    border-bottom: 1px solid ${props => props.theme.border};

    p {
      margin: 0;
      font-size: 14px;
      color: ${props => props.theme.secondaryText};
      line-height: 1.5;

      &:first-child {
        font-weight: 600;
        color: ${props => props.theme.text};
        margin-bottom: 4px;
      }
    }
  }

  .validation-error {
    padding: 12px 16px;
    background: ${props => props.theme.red}15;
    border-bottom: 1px solid ${props => props.theme.border};
    color: ${props => props.theme.red};
    font-size: 14px;
    font-weight: 500;
  }

  .zones-list {
    flex: 1;
    overflow-y: auto;
    padding: 16px;
  }

  .empty-state {
    padding: 40px 20px;
    text-align: center;
    color: ${props => props.theme.secondaryText};

    p {
      margin: 0;
      margin-bottom: 8px;
      font-size: 14px;
    }
  }

  .zone-card {
    background: ${props => props.theme.white};
    border-radius: 12px;
    margin-bottom: 16px;
    cursor: pointer;
    transition: all 0.2s ease;
    overflow: hidden;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);

    &:hover {
      box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
    }

    &.selected {
      background: color-mix(in srgb, var(--zone-color) 4%, ${props => props.theme.white});
      box-shadow:
        0 2px 10px rgba(0, 0, 0, 0.15),
        inset 0 0 0 1px var(--zone-color);
    }
  }

  .zone-header {
    display: flex;
    align-items: center;
    padding: 16px;
    border-bottom: 1px solid ${props => props.theme.border};
  }

  .zone-color-bar {
    width: 4px;
    height: 28px;
    border-radius: 2px;
    background: var(--zone-color);
    flex-shrink: 0;
  }

  .zone-name-input {
    flex: 1;
    min-width: 0;
    font-size: 15px;
    font-weight: 600;
    padding: 4px 8px;
    padding-left: 12px;
    margin: -4px;
    border: none;
    border-radius: 6px;
    background: transparent;
    color: ${props => props.theme.text};
    transition: background 0.15s ease;

    &:hover,
    &:focus {
      background: ${props => props.theme.background};
    }

    &:focus {
      outline: none;
    }

    &::placeholder {
      color: ${props => props.theme.placeholder};
      font-weight: 400;
    }
  }

  .delete-btn {
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${props => props.theme.secondaryText};
    cursor: pointer;
    border-radius: 6px;
    transition: all 0.15s ease;
    flex-shrink: 0;
    font-size: 12px;
    opacity: 0.4;

    &:hover {
      background: ${props => props.theme.red}15;
      color: ${props => props.theme.red};
      opacity: 1;
    }
  }

  .zone-settings {
    padding: 8px 16px 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .setting-row {
    display: flex;
    align-items: center;
    gap: 10px;
    min-height: 36px;
  }

  .setting-label {
    flex: 1;
    font-size: 14px;
    font-weight: 500;
    color: ${props => props.theme.text};
  }

  .toggle {
    width: 44px;
    height: 26px;
    border-radius: 13px;
    cursor: pointer;
    position: relative;
    flex-shrink: 0;

    .toggle-track {
      position: absolute;
      inset: 0;
      border-radius: 13px;
      background: ${props => props.theme.border};
      transition: background 0.2s ease;
    }

    .toggle-knob {
      position: absolute;
      top: 3px;
      left: 3px;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background: ${props => props.theme.white};
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
      transition: left 0.2s ease;
    }

    &.on {
      .toggle-track {
        background: ${props => props.theme.accent};
      }

      .toggle-knob {
        left: 21px;
      }
    }
  }

  .setting-input {
    display: flex;
    align-items: center;
    background: ${props => props.theme.background};
    border-radius: 8px;
    padding: 0 10px;
    height: 36px;
    width: 90px;
    flex-shrink: 0;

    input {
      flex: 1;
      min-width: 0;
      font-size: 16px;
      font-weight: 600;
      border: 1px solid ${props => props.theme.border};
      padding-right: 4px;
      background: transparent;
      color: ${props => props.theme.text};
      text-align: right;

      &:focus {
        outline: none;
      }

      &::-webkit-inner-spin-button,
      &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }

    .unit {
      font-size: 12px;
      color: ${props => props.theme.placeholder};
      font-weight: 500;
      margin-left: 4px;
    }
  }

  .sidebar-footer {
    padding: 16px;
    padding-top: 8px;
    box-shadow: ${props => props.theme.shadow} 0px -4px 12px;
    display: flex;
    flex-direction: column;

    .discard-btn {
      font-size: 14px;
      font-weight: 500;
      color: ${props => props.theme.secondaryText};
      cursor: pointer;
      transition: color 0.15s ease;

      &:hover {
        color: ${props => props.theme.red};
      }
    }
  }

  .map-container {
    flex: 1;
    height: 100%;
    position: relative;

    @media (max-width: 768px) {
      height: 50%;
    }
  }

  .google-map {
    width: 100%;
    height: 100%;
  }

  .restaurant-marker {
    width: 53px;
    height: 53px;
    background: ${props => props.theme.activeBackground};
    border-radius: 26px;
    border-bottom-left-radius: 0;
    box-shadow: 2px 2px 10px ${props => props.theme.shadow};
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 5px solid ${props => props.theme.blue};
    transform: translate(-0%, -100%);
    pointer-events: none;

    .restaurant-logo {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .zone-label {
    transform: translate(-50%, -50%);
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    pointer-events: none;
    padding: 8px 6px;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.75);
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    border: 1px solid rgba(255, 255, 255, 0.5);
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);
    z-index: 2000;

    .zone-label-name {
      font-size: 18px;
      font-weight: 700;
      white-space: nowrap;
      color: var(--label-color);
    }

    .zone-label-info {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
    }

    .zone-label-fee {
      font-size: 14px;
      font-weight: 600;
      color: #000;
      white-space: nowrap;
    }

    .zone-label-detail {
      font-size: 12px;
      font-weight: 500;
      color: #000;
      background: ${props => props.theme.background};
      padding: 3px 8px;
      border-radius: 6px;
      white-space: nowrap;

      &.min {
        color: ${props => props.theme.text};
        background: ${props => props.theme.red}30;
      }

      &.free {
        font-size: 14px;
        font-weight: 600;
        color: ${props => props.theme.text};
        background: ${props => props.theme.green}40;
      }
    }
  }

  .vertex-marker {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    border: 3px solid ${props => props.theme.accent};
    background: ${props => props.theme.white};
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.25);
    transform: translate(-50%, -50%);
    pointer-events: auto;
    cursor: pointer;
    transition:
      transform 0.12s ease,
      background 0.12s ease,
      box-shadow 0.12s ease;

    &:hover {
      transform: translate(-50%, -50%) scale(1.5);
      background: ${props => props.theme.accent};
      box-shadow: 0 4px 14px rgba(0, 0, 0, 0.3);
    }
  }
`
